import React, { useState, useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { SimpleForm } from 'components/forms';
import { FieldsPanel } from 'containers/Dashboard/components/FieldsPanel';
import { validateFields } from 'components/forms/validators';
import { APIRequest } from 'api-provider';
import { getEquipmentsFields } from '../../_shared/fields';
import { PanelFooter } from './PanelFooter';
import { pathEquiments } from "../../_shared/resources";
import { DeleteModal } from '../DeleteModal';

export const EquipmentPanel = ({ data, onSave, hidePanel, onDelete, showDetails, token }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [equipmentData, setEquipmentData] = useState({});
  const [error, setError] = useState(false);

  const fields = getEquipmentsFields();
  const validations = fields
    .filter((item) => item.name === 'enabled')
    .map((item) => ({ field: item.name, required: 1 }));

  const editSuccess = (data) => {
    onSave(data);
    hidePanel(data);
  };

  const editFailure = (data) => {
    setError(data);
  };

  useEffect(() => {
    setEquipmentData({
      entityId: data.entityId,
    });
  }, [data]);

  return (
    <div>
      <APIRequest resource={pathEquiments} onSuccess={editSuccess} onFailure={editFailure}>
        {(request) => {
          return (
            <SimpleForm
              defaultValues={equipmentData}
              validateOnSubmit={true}
              validate={validateFields(validations)}
              reset={!showDetails}
              onSubmit={(values) => { request.fetch({ values, token }); }}
            >
              {({ values, touched }) => {
                return (
                  <div className='panel-flex'>
                    <div>
                      <FieldsPanel
                        configItems={fields}
                        validations={validations}
                      />
                      {request.error && (
                        <Row>
                          <Col md='12'>
                            <div className='request-error'>{request.error}</div>
                          </Col>
                        </Row>
                      )}
                    </div>
                    <div>
                      <>
                        {error && (
                          <div className='error-block'>
                            <Row>
                              <Col md='12'>
                                <div className='request-error'>{error}</div>
                              </Col>
                            </Row>
                          </div>
                        )}
                        <PanelFooter
                          isEdition={equipmentData.serialNumber}
                          touched={touched}
                          isFetching={request.isFetching}
                          showDeleteModal={setShowDeleteModal}
                        />
                      </>
                    </div>
                  </div>
                );
              }}
            </SimpleForm>
          );
        }}
      </APIRequest>

      {showDeleteModal && (
        <DeleteModal
          id={data.entityId}
          token={token}
          deleteSuccess={onDelete}
          showModal={showDeleteModal}
          hideModal={setShowDeleteModal}
        />
      )}
    </div>
  );
};
